import React from "react";
import {BROADCAST_DELAY_SECONDS} from "../../../../common/src/constants";
import TimerTemplate from "../../TimerTemplate";

const StatusPoll = ({poll}) => {
    const {status, display, statusChangedAt} = poll;

    if (status === "result") {
        return <span>Результаты</span>;
    }

    if (status === "active" && display) {
        return <span>Идёт опрос</span>;
    }

    if (status === "active" && !display) {
        return (
            <TimerTemplate
                endTimeSeconds={statusChangedAt + BROADCAST_DELAY_SECONDS}
                textTemplateTimer={"Запущено в залах, в трансляции появится через ${time}"}
                defaultText={"Идёт опрос"}
            />
        );
    }

    return <span></span>;
}

export default StatusPoll;
